export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT ?? 'development';

export const PORT = process.env.PORT ?? 3002;
export const APP_ADDRESS = process.env.REACT_APP_APP_ADDRESS ?? `http://localhost:${PORT}`;

export const FITROOM_APP_ID = process.env.REACT_APP_FITROOM_APP_ID ?? '12345678901234567890';
export const FITROOM_APP_KEY = process.env.REACT_APP_FITROOM_APP_KEY ?? '00000000000000000000';
export const FITROOM_URL = process.env.REACT_APP_FITROOM_URL ?? `http://localhost:3000`;
